import type { Store } from 'pinia'
import type { UserState } from '@/stores/userStore'

export class InactivityHandler {
  private userStore: Store<'user', UserState>
  private handlers: { [key: string]: () => void } = {}

  constructor(userStore: Store<'user', UserState>) {
    this.userStore = userStore
    this.handlers = {
      mousemove: this.resetInactivityTimeout.bind(this),
      keydown: this.resetInactivityTimeout.bind(this),
      click: this.resetInactivityTimeout.bind(this),
      scroll: this.resetInactivityTimeout.bind(this)
    }
  }

  private resetInactivityTimeout() {
    if (this.userStore.isLoggedIn) {
      this.userStore.resetInactivityTimeout()
    }
  }

  public start() {
    Object.entries(this.handlers).forEach(([event, handler]) => {
      window.addEventListener(event, handler)
    })
  }

  public stop() {
    Object.entries(this.handlers).forEach(([event, handler]) => {
      window.removeEventListener(event, handler)
    })
  }
}

// Singleton instance
let instance: InactivityHandler | null = null

export function setupInactivityHandler(userStore: Store<'user', UserState>) {
  if (!instance) {
    instance = new InactivityHandler(userStore)
  }
  instance.start()
  return instance
}

export function stopInactivityHandler() {
  if (instance) {
    instance.stop()
    instance = null
  }
}
